import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  title: {
    id: 'views.ForInvestors.title',
    defaultMessage: 'Relacje inwestorskie'
  },
  bannerButton: {
    id: 'views.ForInvestors.banner.button',
    defaultMessage: 'Zobacz'
  },
  currentReportsTitle: {
    id: 'views.ForInvestors.currentReports.title',
    defaultMessage: 'Raporty bieżące'
  },
  stockPriceChartTitle: {
    id: 'views.ForInvestors.stockPriceChart.title',
    defaultMessage: 'Kurs akcji TenderHut'
  },
  stockPriceChartInfo: {
    id: 'views.ForInvestors.stockPriceChartInfo.p',
    defaultMessage:
      'Wykres online będzie dostępny tutaj po debiucie spółki na New Connect'
  },
  newsTitle: {
    id: 'views.ForInvestors.news.title',
    defaultMessage: 'Aktualności'
  },
  newsEvents: {
    id: 'views.ForInvestors.events.title',
    defaultMessage: 'Planowane wydarzenia'
  },
  newsButton: {
    id: 'views.ForInvestors.news.button',
    defaultMessage: 'Więcej aktualności'
  },
  eventsButton: {
    id: 'views.ForInvestors.events.button',
    defaultMessage: 'Więcej wydarzeń'
  },
  newsletterButton: {
    id: 'views.ForInvestors.newsletter.p',
    defaultMessage: 'Wyślij'
  },
  newsletterWarning: {
    id: 'views.ForInvestors.newsletter.p',
    defaultMessage: 'To pole jest wymagane!'
  },
  newsletterLoading: {
    id: 'views.Contact.Form.buttonMessageLoading',
    defaultMessage: 'Wysyłanie'
  },
  newsletterMessageSuccess: {
    id: 'views.Contact.Form.buttonMessageSuccess',
    defaultMessage: 'Dziekujemy!'
  },
  newsletterEmail: {
    id: 'views.ForInvestors.newsletter.email',
    defaultMessage: 'Adres e-mail'
  },
  contactTitle: {
    id: 'views.ForInvestors.contact.title',
    defaultMessage: 'Kontakt dla inwestorów'
  },
  contactTel: {
    id: 'views.ForInvestors.contact.tel',
    defaultMessage: 'tel.'
  },
  shareholders: {
    id: 'views.ForInvestors.shareholders.title',
    defaultMessage: 'Akcjonariat spółki'
  },
  thgFromWidget: {
    id: 'views.ForInvestors.stockPriceChart.thgFromWidget',
    defaultMessage: 'Wykres giełdowy THG '
  },
  widgetCopyright: {
    id: 'views.ForInvestors.stockPriceChart.widgetCopyright',
    defaultMessage: 'od TradingView'
  }
});



// WEBPACK FOOTER //
// ./src/views/ForInvestors/ForInvestors.intl.js